import { Component } from '@angular/core';
import { TeamListComponent } from './components/team-list/team-list.component';

@Component({
    selector: 'app-teams-view',
    imports: [TeamListComponent],
    templateUrl: './teams-view.component.html',
    styleUrl: './teams-view.component.scss'
})
export class TeamsViewComponent {

}
